import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import UserCell from "@/components/user/UserCell.vue";
let WorkflowStepsList = class WorkflowStepsList extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "workflow", void 0);
    _defineProperty(this, "loading", void 0);
  }
  // noinspection JSUnusedLocalSymbols: used in template
  toUser(uStep) {
    const label = (uStep.userName || '').trim();
    const [first, ...rest] = label.split(/\s+/);
    const last = rest.join(' ');
    return {
      id: 0,
      firstName: first || '',
      lastName: last || '',
      email: uStep.userEmail,
      img: uStep.usrImg || ''
    };
  }
};
__decorate([Prop({
  required: false,
  default: null
})], WorkflowStepsList.prototype, "workflow", void 0);
__decorate([Prop({
  default: false
})], WorkflowStepsList.prototype, "loading", void 0);
WorkflowStepsList = __decorate([Component({
  components: {
    UserCell
  }
})], WorkflowStepsList);
export default WorkflowStepsList;